// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Db+Gr","inner":"Footer_inner__kA8dI","brand":"Footer_brand__i-roy","copy":"Footer_copy__jltXn","right":"Footer_right__rCQz2","sep":"Footer_sep__D82hw"};